import axios from 'axios';

export const actions = {
    getBots() {
        return axios.$get('/v1/discord/bots');
    },

    getServers() {
        return axios.$get('/v1/discord/servers');
    },

    // Deleting a server row means our bot leaves the customer's Discord server.
    leaveServer(vuexContext, id) {
        return axios.$delete(`/v1/discord/servers/${id}`);
    }
};
